var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.708984,
    y: 0.115234,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#7043FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.709 29.1152C15.7464 29.1152 11.709 25.0778 11.709 20.1152C11.709 15.1527 15.7464 11.1152 20.709 11.1152C25.6715 11.1152 29.709 15.1527 29.709 20.1152C29.709 25.0778 25.6733 29.1152 20.709 29.1152ZM20.709 12.4585C16.487 12.4585 13.0523 15.8933 13.0523 20.1152C13.0523 24.3372 16.487 27.7719 20.709 27.7719C24.9309 27.7719 28.3657 24.3372 28.3657 20.1152C28.3657 15.8933 24.9309 12.4585 20.709 12.4585Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7479 15.0453C21.1131 15.0453 21.4092 15.3413 21.4092 15.7066V19.8414L23.8607 22.2929C24.119 22.5512 24.119 22.9699 23.8607 23.2282C23.6025 23.4864 23.1837 23.4864 22.9255 23.2282L20.2802 20.5829C20.1562 20.4589 20.0865 20.2907 20.0865 20.1153V15.7066C20.0865 15.3413 20.3826 15.0453 20.7479 15.0453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopResponse);
export default __webpack_public_path__ + "static/media/stop_response.8a6c53b2571b9dafc375c73b91d0620e.svg";
export { ForwardRef as ReactComponent };